import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";

export function CardSkeleton({ count = 1 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Grid item xs={12} md={6} lg={3} key={i}>
          <MDBox mb={1.5}>
            <Skeleton variant="rounded" height={120} />
          </MDBox>
        </Grid>
      ))}
    </>
  );
}

export function ChartSkeleton({ height = 320 }: { height?: number }) {
  return <Skeleton variant="rounded" height={height} sx={{ mb: 3 }} />;
}

export function ListSkeleton({ height = 280 }: { height?: number }) {
  return <Skeleton variant="rounded" height={height} />;
}
